import { Component, signal } from '@angular/core';
import { IconComponent } from '@lp/components/icon';

@Component({
  selector: 'lp-clipboard-button',
  templateUrl: 'clipboard-button.component.html',
  styleUrl: 'clipboard-button.component.scss',
  imports: [IconComponent],
  host: {
    '(click)': 'copy()'
  }
})
export class ClipboardButtonComponent {
  public copied = signal(false);

  public copy(): void {
    this.copied.set(true);
    setTimeout(() => {
      this.copied.set(false);
    }, 2000);
  }
}
